export const orderHistoryService = {
  // Save order to localStorage with 24-hour expiration
  saveOrder(orderData, restaurant) {
    try {
      const history = this.getHistory();
      const orderRecord = {
        id: orderData.id,
        orderNumber: orderData.order_number,
        items: orderData.items,
        totalAmount: orderData.total_amount,
        restaurant: {
          name: restaurant.name,
          slug: restaurant.slug
        },
        timestamp: Date.now(),
        expiresAt: Date.now() + (24 * 60 * 60 * 1000), // 24 hours
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString()
      };
      
      history.unshift(orderRecord);
      const trimmedHistory = history.slice(0, 20);
      
      localStorage.setItem('menuron_order_history', JSON.stringify(trimmedHistory));
      return true;
    } catch (error) {
      console.error('Failed to save order history:', error);
      return false;
    }
  },

  // Get order history, filtering expired orders
  getHistory() {
    try {
      const history = localStorage.getItem('menuron_order_history');
      if (!history) return [];
      
      const allOrders = JSON.parse(history);
      const now = Date.now();
      
      const validOrders = allOrders.filter(order => {
        return !order.expiresAt || order.expiresAt > now;
      });
      
      if (validOrders.length !== allOrders.length) {
        localStorage.setItem('menuron_order_history', JSON.stringify(validOrders));
      }
      
      return validOrders;
    } catch (error) {
      console.error('Failed to load order history:', error);
      return [];
    }
  },

  clearHistory() {
    try {
      localStorage.removeItem('menuron_order_history');
      return true;
    } catch (error) {
      return false;
    }
  },

  getHistoryCount() {
    return this.getHistory().length;
  }
};